import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=52986f6d&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=52986f6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52986f6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52986f6d')) {
      api.createRecord('52986f6d', component.options)
    } else {
      api.reload('52986f6d', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=52986f6d&scoped=true&", function () {
      api.rerender('52986f6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C07swQ0fYdp1/JS/comp/PopupBox.vue"
export default component.exports